const state = {
  changeType: null,
  payOff: null
}

// getters
const getters = {
  getPPSMultiChangeType: (state) => {
    return state.changeType
  },
  getPPSMultiPayOff: (state) => {
    return state.payOff
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  setPPSMultiChangeType (state, payload) {
    state.changeType = payload
  },
  setPPSMultiPayOff (state, payload) {
    state.payOff = payload
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
